export default "__VITE_ASSET__Bjm5o4hf__"